import { z } from 'zod';
import { idSchema, timestampsSchema } from './common';
import { runStageNameSchema } from './stage';

export const clarificationStatuses = ['open', 'answered', 'expired'] as const;
export const clarificationStatusSchema = z.enum(clarificationStatuses);
export type ClarificationStatus = z.infer<typeof clarificationStatusSchema>;

/** `clarify` = bounded planning question; `escalation` = operator triage handoff. */
export const clarificationKinds = ['clarify', 'escalation'] as const;
export const clarificationKindSchema = z.enum(clarificationKinds);
export type ClarificationKind = z.infer<typeof clarificationKindSchema>;

/**
 * A governed planning question (Epic J3) raised during Triage/Plan when intake
 * confidence is partial/low, or an operator escalation when unclassifiable. An
 * answer resumes the run.
 */
export const runClarificationSchema = z
  .object({
    id: idSchema,
    tenantId: idSchema,
    runId: idSchema,
    stage: runStageNameSchema.default('Plan'),
    kind: clarificationKindSchema.default('clarify'),
    question: z.string(),
    answer: z.string().nullish(),
    status: clarificationStatusSchema.default('open'),
    askedAt: z.coerce.date().nullish(),
    answeredAt: z.coerce.date().nullish(),
  })
  .merge(timestampsSchema.partial());
export type RunClarification = z.infer<typeof runClarificationSchema>;

export const answerClarificationSchema = z.object({
  answer: z.string().min(1).max(4000),
});
export type AnswerClarification = z.infer<typeof answerClarificationSchema>;
